import { codeSplit, Controller, FetchOptions } from 'bernie-core';
import { KeyedObject } from 'bernie-core/dist/source';
import { ActivityDetailStore } from '../stores';

export class ActivityDetailLangController implements Controller {
  public pageId = 'ActivityDetails';
  public path = '/things-to-do/:lang/:title?.a:activityId\\.([a-z\\-]{5,})';
  public routeName = 'activity-detail';
  public bundles: string[] = [];

  // eslint-disable-next-line import/no-unresolved
  public component = codeSplit(() => import(/* webpackChunkName: "example-page" */ 'views/test'));
  public exact = true;

  public async fetch(options: FetchOptions): Promise<any> {
    const { stores } = options;
    const activityDetailStore: ActivityDetailStore = stores.get<ActivityDetailStore>('activityDetailStore');

    const unwantedKeys = ['lang', 'title', 'activityId', '0'];
    const lang = this.getLang(options.query);
    const queryObject: KeyedObject & { langid: string } = { ...options.query, ...{ langid: lang.toString() } };
    activityDetailStore.detailUrl = `${`/things-to-do/${options.query.title}.a${options.query.activityId}.${options.query['0']}?`}${Object.keys(
      queryObject
    )
      .filter((t) => unwantedKeys.indexOf(t) === -1)
      .map((key) => `${key}=${queryObject[key]}`)
      .join('&')}`;

    return Promise.resolve();
  }

  protected getLang(params: KeyedObject): number {
    if (params && params.lang) {
      switch (params.lang) {
        case 'es':
          return 2058;
        case 'zh':
          return 2052;
        default:
          return 0;
      }
    }

    return 0;
  }

  public fetchPageData(): Promise<{ title: string; pageId: string }> {
    return Promise.resolve({ title: '', pageId: this.pageId });
  }

  public isDialogChange(query: KeyedObject): boolean {
    const { prev } = query;

    return Boolean(prev.pwaDialog);
  }
}
